import React from 'react';
import { Button } from 'antd';

export default function TextButton({
  label,
  link,
}: {
  label: string;
  link: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        height: '100%',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
        }}
      >
        <Button
          type='link'
          href={link}
          target='_blank'
          rel='noopener noreferrer'
          style={{
            fontSize: '12px',
            padding: '0',
            height: 'auto',
            textAlign: 'center',
            wordBreak: 'break-word',
          }}
        >
          {label}
        </Button>
      </div>
    </div>
  );
}
